/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Log_In_TitleInputs */

const en_dialog_log_in_title = /** @type {(inputs: Dialog_Log_In_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please Log In/Sign Up`)
};

const ar_dialog_log_in_title = /** @type {(inputs: Dialog_Log_In_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الرجاء تسجيل الدخول/التسجيل`)
};

const de_dialog_log_in_title = /** @type {(inputs: Dialog_Log_In_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte anmelden/registrieren`)
};

const es_dialog_log_in_title = /** @type {(inputs: Dialog_Log_In_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicia sesión/regístrate`)
};

const fr_dialog_log_in_title = /** @type {(inputs: Dialog_Log_In_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez vous connecter/vous inscrire`)
};

const it_dialog_log_in_title = /** @type {(inputs: Dialog_Log_In_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ti preghiamo di accedere o di registrarti`)
};

const ja_dialog_log_in_title = /** @type {(inputs: Dialog_Log_In_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ログイン/サインアップしてください`)
};

const ko_dialog_log_in_title = /** @type {(inputs: Dialog_Log_In_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로그인/가입하세요`)
};

const pt_br_dialog_log_in_title = /** @type {(inputs: Dialog_Log_In_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicie sessão/Registre-se`)
};

const ru_dialog_log_in_title = /** @type {(inputs: Dialog_Log_In_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Войдите / зарегистрируйтесь`)
};

const th_dialog_log_in_title = /** @type {(inputs: Dialog_Log_In_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โปรดเข้าสู่ระบบ/ลงทะเบียน`)
};

const tr_dialog_log_in_title = /** @type {(inputs: Dialog_Log_In_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lütfen Giriş Yap/Kaydol`)
};

const zh_cn_dialog_log_in_title = /** @type {(inputs: Dialog_Log_In_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请先登录/注册`)
};

const zh_tw_dialog_log_in_title = /** @type {(inputs: Dialog_Log_In_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`請先登入/註冊`)
};

/**
* | output |
* | --- |
* | "Please Log In/Sign Up" |
*
* @param {Dialog_Log_In_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_log_in_title = /** @type {((inputs?: Dialog_Log_In_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Log_In_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_log_in_title(inputs)
	if (locale === "ar") return ar_dialog_log_in_title(inputs)
	if (locale === "de") return de_dialog_log_in_title(inputs)
	if (locale === "es") return es_dialog_log_in_title(inputs)
	if (locale === "fr") return fr_dialog_log_in_title(inputs)
	if (locale === "it") return it_dialog_log_in_title(inputs)
	if (locale === "ja") return ja_dialog_log_in_title(inputs)
	if (locale === "ko") return ko_dialog_log_in_title(inputs)
	if (locale === "pt_br") return pt_br_dialog_log_in_title(inputs)
	if (locale === "ru") return ru_dialog_log_in_title(inputs)
	if (locale === "th") return th_dialog_log_in_title(inputs)
	if (locale === "tr") return tr_dialog_log_in_title(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_log_in_title(inputs)
	return zh_tw_dialog_log_in_title(inputs)
});